import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PulseMark } from "@/components/layout/PublicShell";
import { useCity } from "@/contexts/CityContext";

/**
 * Focused frame for single-task pages (sign in, join, claim, confirm,
 * verify, unsubscribe): brand bar, one centred column, slim footer. No site
 * navigation competing with the one thing the page asks for.
 */
export function FocusShell({ children, width = "narrow" }: { children: ReactNode; width?: "narrow" | "wide" }) {
  const { city } = useCity();
  return (
    <div className="ds-site ds-focus">
      <header className="ds-focus__bar">
        <div className="ds-container">
          <Link to="/" className="ds-brand" aria-label={`PulseBoard ${city.name} home`}>
            <PulseMark />
            <span>PulseBoard</span>
            <span className="ds-brand__city">{city.name}</span>
          </Link>
        </div>
      </header>
      <main id="main" className="ds-site__main">
        <div className={`ds-container ${width === "narrow" ? "ds-container--narrow" : ""}`.trim()}>
          <div className="ds-focus__body">{children}</div>
        </div>
      </main>
      <footer className="ds-focus__foot">
        <div className="ds-container ds-cluster" style={{ justifyContent: "space-between" }}>
          <span className="ds-fine">© {new Date().getFullYear()} Amida Health Pty Ltd · Data hosted in Australia</span>
          <span className="ds-cluster" style={{ gap: 16 }}>
            <Link className="ds-fine" to="/privacy">Privacy</Link>
            <Link className="ds-fine" to="/terms">Terms</Link>
          </span>
        </div>
      </footer>
    </div>
  );
}
